<template>
    <!-- Project 2 - Bootstrap Brain Component -->
    <section class="bg-dark py-5 py-xl-8">
        <div class="container">
            <div class="row justify-content-md-center">
                <div class="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
                    <h2 class="mb-4 display-5 text-center">KEGIATAN KAMI</h2>
                    <p class="text-secondary mb-5 text-center lead fs-4">Kami berkomitmen untuk bekerja sama untuk
                        mengembangkan dan melayani dengan sepenuh hati.</p>
                    <hr class="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle">
                </div>
            </div>
        </div>

        <div class="container overflow-hidden">
            <div class="row gy-2 g-md-2 g-xl-3 bsb-project-2-grid">
                <div v-for="news in newsList" :key="news.id" class="col-12 col-md-4 bsb-project-2-item">
                    <figure class="rounded rounded-3 overflow-hidden bsb-overlay-hover m-0">
                        <a href="#!">
                            <img class="img-fluid bsb-scale-up bsb-hover-scale"
                                :src="`https://bkpsdm.kendalkab.go.id/bahurekso/packages/upload/galeri/${news.foto}`"
                                
                                alt="Photography">
                            <!-- <img class="img-fluid bsb-scale-up bsb-hover-scale"
                                :src="`https://bkpsdm.kendalkab.go.id/packages/upload/galeri/${news.foto}`"
                                @error="$event.target.src='http://localhost:8080/portal/img/logowarna.df57258c.png'"
                                alt="Photography"> -->
                        </a>
                        <figcaption>
                            <h3 class="text-white bsb-hover-fadeInLeft">{{ news.keterangan }}</h3>
                            <div class="text-white bsb-hover-fadeInRight">{{ formatDate(news.created_at) }}</div>
                        </figcaption>
                    </figure>
                </div>


            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";

export default {
    name: "BeritaTerkini",
    data() {
        return {
            newsList: [],
            loading: true,
            error: null,
        };
    },
    methods: {
        async fetchNews() {
            try {
                const response = await axios.get("galeri");
                this.newsList = response.data.data;
                // console.log(response.data)
            } catch (err) {
                this.error = "Gagal memuat galeri. Coba lagi nanti.";
            } finally {
                this.loading = false;
            }
        },
        formatDate(date) {
            const options = { year: "numeric", month: "long", day: "numeric" };
            return new Date(date).toLocaleDateString("id-ID", options);
        },
    },
    created() {
        this.fetchNews();
    },
};
</script>

<style></style>